<template>
  <div class="testOnePhone">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item, k) in dataList" v-if="k % 2 === 0">
        <div class="imgBar">
          <div class="imgNavs clear">
            <div
              class="imgNav left"
              v-for="(currect, i) in dataList.slice(k)"
              v-if="i < 2"
            >
              <img :src="currect.imgPath3" />
              <div class="striping">
                <p class="p1">{{ currect.title }}</p>
                <p class="p2">{{ currect.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<style>
.testOnePhone {
  padding-top: 15px;
  padding-bottom: 15px;
}

.testOnePhone .imgBar {
  width: 100%;
  /* 
		margin-top: 80px; */
}

.testOnePhone .imgNavs {
  width: 85%;
  margin: 0 auto;
  margin-left: 12px;
}

.testOnePhone .imgNavs .imgNav {
  /* width: 50%; */

  width: 45%;
  margin: 0 auto;
}

.testOnePhone .imgNav img {
  width: 95%;
  margin: 0 auto;
  margin-left: 34px;
  padding-bottom: 10px;
  /* border-bottom: 1px solid #C4C4C4; */
}

.testOnePhone .el-carousel__container {
  width: 100%;
  height: 270px;
  margin: 0 auto;
}

.testOnePhone .el-carousel__arrow {
  background-color: rgba(31, 45, 61, -0.89);
  color: #ccb356;
  top: 30%;
}

.testOnePhone .el-carousel__arrow:hover {
  background-color: rgba(31, 45, 61, -0.89);
  color: #ccb356;
}

.testOnePhone .el-carousel__arrow--left {
  /* margin-left: 8px; */
}

.testOnePhone .el-icon-arrow-left {
  font-size: 30px;
  outline: none;
}

button:focus {
  outline: none;
}

.testOnePhone .el-icon-arrow-right {
  font-size: 30px;
  /* margin-right: -32px; */
  /* margin-left:43px; */
  outline: none;
}

.testOnePhone .el-carousel__indicators--outside {
  display: none;
}

.testOnePhone .striping {
  border-top: 1px solid #c4c4c4;
  width: 70%;
  margin-left: 47px;
}

.testOnePhone .striping p {
  text-align: center;
  color: #595757;
  margin-bottom: 0;
}

.testOnePhone .striping .p1 {
  font-size: 10px;
  margin-top: 10px;
  letter-spacing: 0.3px;
}

.testOnePhone .striping .p2 {
  margin-top: 5px;
  font-size: 15px;
}
</style>

<script>
export default {
  name: "testOnePhone",
  props: ["dataList"],
  data() {
    return {
      //dataList: []
    };
  },
  mounted() {
    /* let that = this;
			that.$axios.get(that.$global.baseURL + '/web/productList/getProductDataByType.form', {
				params: {
					type: "4"
				}
			}).then(res => {
				if (res.data.jsonArray == 'error') {
					uni.showModal({
						title: res.data.errorInfo,
						showCancel: false
					});
				} else {
					that.dataList = res.data.dataList;
				}
			}); */
  }
};
</script>
